// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"163":"map","187":"search"}[chunkId] || chunkId) + "." + {"163":"09e472a5","187":"28797093","209":"10d0b1d9","227":"be3955c4"}[chunkId] + ".chunk.js";
};